import React from 'react';
import { MessageCircle } from 'lucide-react';
import lojaImg from '../../../assets/CasadoPandeiro_loja.jpeg';

const WHATSAPP_LINK = 'https://wa.me/5521986013006';

export const LojaPage: React.FC = () => {
  return (
    <div>
      <div
        className="w-full"
        style={{
          backgroundImage: `url(${lojaImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
        role="img"
        aria-label="Loja da Casa do Pandeiro"
      >
        <div className="container py-40 md:py-56" />
      </div>

      <div className="container pt-8 pb-16 md:pt-12 md:pb-20 max-w-3xl mx-auto">
        <h1 className="text-3xl md:text-4xl text-primary mb-6">Loja</h1>

        <p className="text-foreground leading-relaxed mb-4">
          Leve um pedacinho da Casa do Pandeiro com você. Temos pandeiros de várias partes do Brasil,
          bolsas para pandeiro, livros, instrumentos de percussão, camisetas e muito mais.
        </p>

        <p className="text-foreground leading-relaxed mb-8">
          Ainda não temos loja virtual, mas você pode falar com a gente para saber o que está disponível.
        </p>

        <a
          href={WHATSAPP_LINK}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary text-primary-foreground font-medium hover:opacity-90 transition-opacity"
        >
          <MessageCircle size={18} />
          Falar pelo WhatsApp
        </a>
      </div>
    </div>
  );
};
